export * from './pages-routing-shared.module';
